import React, { useEffect, useState } from "react";
import { ReactComponent as Checked } from "../../assets/analyse/Checked.svg";
import { ReactComponent as Unchecked } from "../../assets/analyse/Unchecked.svg";
import { columnsNames } from "../../css/columns";

// REDUX
import { useSelector, shallowEqual } from "react-redux";
// import { current } from "@reduxjs/toolkit";

const StepResult = ({ result, columns, totalScore, step_index }) => {

  return (
    <div className={`h-[40px]  bg-blue-300/30 flex items-center w-max`}>
      {/* <div className={`h-[40px] w-[601px] flex items-center`}> */}
      <div className={`h-[40px] w-[591px] ml-[10px] flex items-center`}>
        <p className="font-Poppins-Regular text-sm ml-[40px]">{result.flow.name_fr}</p>
      </div>

      <div className=" h-[40px] flex justify-start items-center"></div>
    </div>
  );
};

export default StepResult;
